define("Item.KeyMapping.Ext", [
  "Item.KeyMapping",
  "SC.Configuration",
  "underscore",
  "Utils",
  "UrlHelper",
], function extendKeyMapping(ItemsKeyMapping, Configuration, _, Utils) {
  "use strict";

  ItemsKeyMapping.getKeyMapping = _.wrap(
    ItemsKeyMapping.getKeyMapping,
    function wrapKeyMapping(fn) {
      var originalItemsKeyMapping = fn.apply(
        this,
        _.toArray(arguments).slice(1)
      );
      var newKeyMapping = _.extend(originalItemsKeyMapping, {
        _thumbnail: function (item) {
          if (item.get("custitemitemimageurl1")) {
            return {
              url: item.get("custitemitemimageurl1"),
              altimagetext: item.get("_name"),
            };
          }
          // still nothing? image the not available
          return {
            url: Utils.getThemeAbsoluteUrlOfNonManagedResources(
              "img/no_image_available.jpeg",
              Configuration.get("imageNotAvailable")
            ),
            altimagetext: item.get("_name"),
          };
        },

        _comparePriceAgainst: function (item) {
          var prices = item.get("_priceDetails"),
            strikePrice = item.get("pricelevel1");

          if (!strikePrice && prices) {
            if (prices.priceschedule && prices.priceschedule.length > 0) {
              strikePrice = prices.priceschedule[0].price;
            } else {
              strikePrice = prices.onlinecustomerprice;
            }
          }
          return strikePrice;
        },

        _comparePriceAgainstFormated: function (item) {
          var prices = item.get("_priceDetails"),
            strikePriceFormatted = item.get("pricelevel1_formatted");

          // Matrix/assembly items may have pricelevel1 (numeric) but NOT
          // pricelevel1_formatted.  When that happens the formatted fallback
          // chain resolves to onlinecustomerprice_formatted (the discounted
          // price) while the numeric function returns the correct retail
          // price — causing the strikethrough to equal the current price.
          // Fix: format the numeric value ourselves when the formatted field
          // is missing.
          if (!strikePriceFormatted) {
            var numericPrice = item.get("pricelevel1");
            if (numericPrice) {
              var currencySymbol = SC.getSessionInfo("currency")
                ? SC.getSessionInfo("currency").symbol
                : "$";
              strikePriceFormatted = Utils.formatCurrency(numericPrice, currencySymbol);
            }
          }

          if (!strikePriceFormatted && prices) {
            if (prices.priceschedule && prices.priceschedule.length > 0) {
              strikePriceFormatted = prices.priceschedule[0].price_formatted;
            } else {
              strikePriceFormatted = prices.onlinecustomerprice_formatted;
            }
          }
          return strikePriceFormatted;
        },
      });

      return newKeyMapping;
    }
  );
});
